import React, { useState } from "react";
import "./performance-table.css";

const PerformanceTable = ({ data }) => {
    const [expandedRM, setExpandedRM] = useState([]);

    // Toggle expand/collapse for RM
    const toggleRM = (index) => {
        setExpandedRM((prev) => {
            if (prev.includes(index)) {
                // If already open → remove (collapse)
                return prev.filter((i) => i !== index);
            } else {
                // If closed → add (expand)
                return [...prev, index];
            }
        });
    };

    const periods = data[0]?.rmTotal?.map((p) => ({
        start: new Date(p.period_start).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
        }),
        end: new Date(p.period_end).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
        }),
    }));

    return (
        <div className="performance-container">
            <div className="performance-header">
                <h2 className="performance-title">
                    Performance Data - Patient Registration
                </h2>
            </div>
            <table className="performance-table">
                <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Trend</th>
                        {periods?.map((p, i) => (
                            <th key={i}>{`${p.start} - ${p.end}`}</th>
                        ))}
                        <th>Total</th>
                        <th>Target</th>
                        <th>Pain Category Avg</th>
                        <th>Zone Avg</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {data.map((rm, i) => {
                        const rmTotal = rm.rmTotal.reduce((acc, p) => acc + p.usage_count, 0);
                        const isExpanded = expandedRM.includes(i);

                        return (
                            <React.Fragment key={i}>
                                {/* RM ROW */}
                                <tr className={`rm-row ${rmTotal < 50 ? "low-performance" : ""}`}>
                                    <td className="dropdown-cell" onClick={() => toggleRM(i)}>
                                        <span className={`arrow ${expandedRM.includes(i) ? "down" : "right"}`}></span>
                                    </td>
                                    <td className="clickable" onClick={() => toggleRM(i)}>
                                        {rm.rmName}
                                    </td>
                                    <td><span className="role-badge">RM</span></td>
                                    <td>📈</td>

                                    {/* Always render cells for all periods */}
                                    {periods.map((_, idx) => {
                                        const value = rm.rmTotal[idx]?.usage_count ?? "";
                                        return <td key={idx}>{value}</td>;
                                    })}

                                    <td className="highlight">{rmTotal}</td>
                                    <td>31.5</td>
                                    <td>9.6</td>
                                    <td>27.4</td>
                                    <td><button onClick={() => toggleRM(i)} className="view-btn">View Team</button></td>
                                </tr>

                                {/* MR ROWS */}
                                {isExpanded &&
                                    rm.mrData.map((mr, mIndex) => {
                                        const mrTotal = mr.mrCodeData.reduce(
                                            (acc, p) => acc + p.usage_count, 0
                                        );
                                        return (
                                            <tr key={mIndex} className={`mr-row ${mrTotal < 20 ? "low-performance" : ""}`}>
                                                <td></td>
                                                <td className="mr-name">{mr.mrName}</td>
                                                <td><span className="role-badge mr">MR</span></td>
                                                <td>📉</td>

                                                {/* Always render cells for all periods */}
                                                {periods.map((_, idx) => {
                                                    const value = mr.mrCodeData[idx]?.usage_count ?? "";
                                                    return <td key={idx}>{value}</td>;
                                                })}

                                                <td className="highlight">{mrTotal}</td>
                                                <td>31.5</td>
                                                <td>9.6</td>
                                                <td>27.4</td>
                                                <td></td>
                                            </tr>
                                        );
                                    })}

                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default PerformanceTable;
